import { combineReducers } from 'redux';
import actions from '../actions';
import MapApi from '@mgc/map-client-shared/lib/MapApi';
import cart from './cart';
import help from './help';
import joyride from './joyride';
import login from './login';
import offer from './offer';
import order from './order';
import ui from './ui';
import user from './user';
import sites from './sites';
import configurations from './uploadConfiguration';
import error from './error';

export default combineReducers({
    // We can make the API client without the XSRF token here no problem. We
    // just can't use it to make any authenticated calls.
    api: (state = new MapApi(), action) => {
        switch (action.type) {
            case actions.STORE_XSRF_TOKEN:
                return new MapApi(action.payload.xsrfToken);
            default:
                return state;
        }
    },

    myself: (state = null, action) => {
        switch (action.type) {
            case actions.RECEIVED_USER:
                return action.payload.response;

            case actions.UPDATED_PREFERENCES:
                return Object.assign({}, state, {
                    preferences: action.payload.response,
                });

            default:
                return state;
        }
    },

    cart,
    help,
    joyride,
    login,
    offer,
    order,
    ui,
    user,
    sites,
    configurations,
    error,
});



// WEBPACK FOOTER //
// ./app/reducers/index.js